export const accentColors = ['blue', 'green', 'orange', 'pink', 'teal'] as const;
